import { Outlet } from "react-router-dom";
import MainHeader from "@/components/sections/MainHeader";
import SubHeader from "@/components/sections/SubHeader";
import NavBar from "@/components/sections/NavBar";

import { useSelector } from "react-redux";
import { useMatches } from "react-router-dom";

import NotificationContainer from "@/libraries/notification/NotificationContainer";
import { useNotification } from "@/libraries/notification/NotificationContext"
import { NOTIFICATION } from "@/constants"
import TickerTape from "@/components/units/TickerTape";
import { tickerTapeData } from "@/components/units/TickerTape/tickerTapeData";

export default function Layout() {
  const { notificationList } = useNotification(NOTIFICATION.NOTIFICATION);
  const { notificationList:toastList } = useNotification(NOTIFICATION.TOAST);

  const mainHeaderVisibility = useSelector(
    (state) => state.global.mainHeaderVisibility
  );
  const subHeaderTitle = useSelector((state) => state.global.subHeaderTitle);
  const userData = useSelector((state) => state.user.user);
  const navBarVisibility = useSelector(
    (state) => state.global.navBarVisibility
  );
  
  const { showTicker } = useSelector((state) => state.featureflag.ticker)
  
  const matches = useMatches();
  const routeHandle =
  matches?.reduce((masterHandle, { handle }) => {
    return {
      ...masterHandle,
      ...handle,
    };
  }, {}) || {};
  
  const tickerEnabled = showTicker && routeHandle.hasTickerTape
  const routeHasSubHeader = typeof routeHandle.subHeaderTitle === "string";

  let topPadding = "tw-pt-0";
  if (
    routeHandle.hasMainHeader &&
    mainHeaderVisibility &&
    routeHasSubHeader &&
    subHeaderTitle
  ) {
    if(tickerEnabled){
      topPadding = "tw-pt-[152px]";
    } else {
      topPadding = "tw-pt-28";
    }
  } else if (
    (routeHandle.hasMainHeader && mainHeaderVisibility) ||
    (routeHasSubHeader && subHeaderTitle)
  ) {
    if(tickerEnabled){
      topPadding = "tw-pt-[120px]";
    } else {
      topPadding = "tw-pt-[104px]";
    }
  } else {
    if(tickerEnabled){
      topPadding = "tw-pt-10";
    }
  }
  let bottomPadding = "tw-pb-0";
  if (routeHandle.hasNavBar && navBarVisibility) {
    bottomPadding = "tw-pb-[72px]";
  }

  return (
    <div className="tw-flex tw-flex-col tw-items-stretch tw-justify-stretch tw-relative">
      <div className={`tw-relative tw-min-h-dvh tw-bg-[#FAFAFC] ${topPadding} ${bottomPadding}`}>
        <Outlet />
      </div>
      <div className="tw-fixed tw-z-50 tw-h-[100vh]">
        <NavBar userData={userData} activeMenuTitle="Home" />
      </div>
      <div id="modal-container"></div>
      <NotificationContainer notificationList={notificationList} type={NOTIFICATION.NOTIFICATION}/>
      <NotificationContainer notificationList={toastList}  type={NOTIFICATION.TOAST}/>
      <div className="tw-fixed tw-top-0 tw-z-40 tw-w-full tw-flex tw-flex-col tw-items-stretch">
        {tickerEnabled && <TickerTape data={tickerTapeData} />}
        {/* {routeHandle.hasTickerTape && "Hello"} */}
        {
          // TODO: apply conditional styling classes instead for smooth transition
          routeHandle.hasMainHeader && mainHeaderVisibility && <MainHeader userData={userData}/>
        }
        {routeHasSubHeader && (
          <SubHeader/>
        )}
      </div>
    </div>
  );
}
